module.exports = __webpack_public_path__ + "static/contact_tablet-8a1bb2428df20eb4704a4dcc13658bb9.jpg";